export const validateAndGetInternalRedirectUrl = (value?: string | null): string | null => {
  if (!value) {
    return null
  }
  try {
    const url = new URL(value, window.location.origin)
    return url.origin === window.location.origin ? url.href : null
  } catch {
    return null
  }
}
